import { createContext, Dispatch, SetStateAction } from 'react';

interface ActiveSampleDatasetContextValue {
  activeDatasetId: string | null;
  setActiveDatasetId: Dispatch<SetStateAction<string | null>>;
}

export const ActiveSampleDatasetContext =
  createContext<ActiveSampleDatasetContextValue>({
    activeDatasetId: null,
    setActiveDatasetId: () => void 0,
  });
